import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RxAlertCount } from "../../Apis/AuthApiServices";
import {
  loadingRxAlertsCount,
  setRxAlertsCount,
} from "../Slice/RxAlertsCountSlice";

function* onLoadRxAlertsCountAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield RxAlertCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRxAlertsCount({
          RxAlertsCountData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRxAlertsCount({
          RxAlertsCountData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRxAlertsCount({
        RxAlertsCountData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRxAlertsCount() {
  yield takeLatest(loadingRxAlertsCount.type, onLoadRxAlertsCountAsync);
}

const RxAlertsCountSaga = [fork(onLoadRxAlertsCount)];
export default RxAlertsCountSaga;
